<template>
    <div class="container person">
        <div class="person-head">{{title}}</div>
        <div class="person-footer flex">
            <div class="person-left">
                <ul>
                    <router-link
                    @click.native="title = linkTitle[index]"
                    v-for="(item, index) in linkList"
                    :key="index"
                    tag="li"
                    :class="{'active': $route.name === item.link}"
                    :to="{name: item.link}">{{ item.name }}</router-link>
                </ul>
            </div>
            <div class="person-right flex-1">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Person',
    watch: {
        '$route'(to, from) {
            this.linkList.forEach((item, index) => {
                if (this.$route.name === item.link) {
                    this.currentIndex = index;
                    this.title = this.linkTitle[index];
                }
            });
        },
    },
    data() {
        return {
            linkIndex: 0,
            title: '',
            linkTitle: [
                'MY ACCOUNT',
                'MY ORDERS',
                'FEEDBACK',
            ],
            currentIndex: 0,
            linkList: [
                {
                    link: 'PersonInfo',
                    name: 'Personal details',
                },
                {
                    link: 'PersonOrders',
                    name: 'My Orders',
                },
                {
                    link: 'PersonBack',
                    name: 'Feedback',
                },
            ],
        };
    },
    methods: {

    },
    created() {
        this.linkList.forEach((item, index) => {
            if (this.$route.name === item.link) {
                this.currentIndex = index;
                this.title = this.linkTitle[index];
            }
        });
    },
};
</script>

<style lang="scss" scoped>
    .person {
        margin-top: 71px;
        padding-bottom:200px;
        .person-head {
            font-family: PingFangSC-Medium;
            font-size: 40px;
            color: #292220;
            letter-spacing: 0;
            padding: 30px 0 17px;
        }
        .person-left {
            width: 160px;
            margin-right: 10px;
            li {
                cursor: pointer;
                height: 48px;
                margin-bottom: 2px;
                background-color: #fff;
                text-align: center;
                line-height: 48px;
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #4A4A4A;
                letter-spacing: 0;
                transition: all .5s;
            }
            li.active {
                font-family: PingFangSC-Semibold;
                color: #F75C75;
            }
        }
    }
</style>
